// JS for LPv2 Main Product Swatches block
export function initSwatchesBlock() {
	
	if (!window.LPV2ProductVariants) return;
	const stateManager = window.lpv2MainProductStateManager || new window.LPV2MainProductStateManager();

	function updateActiveSwatch(optionName) {
		const radios = document.querySelectorAll('.lpv2-variant-radios[data-option="' + optionName + '"] input[type="radio"]');
		radios.forEach(function(radio) {
			const wrapper = radio.closest('.lpv2-variant-wrapper');
			if (wrapper) {
				if (radio.checked) {
					wrapper.classList.add('active');
				} else {
					wrapper.classList.remove('active');
				}
			}
		});
	}

	// On page load, set .active for all option groups
	document.querySelectorAll('.lpv2-variant-radios').forEach(function(group) {
		const optionName = group.getAttribute('data-option');
		updateActiveSwatch(optionName);
	});

	const radios = document.querySelectorAll('.lpv2-variant-wrapper input[type="radio"]');
	radios.forEach(function (radio) {
		
		radio.addEventListener('change', function () {
			// Get the option name for the clicked radio
			const optionName = radio.closest('.lpv2-variant-radios').getAttribute('data-option');
			updateActiveSwatch(optionName);
			
			// Collect ALL currently selected option values from all radio groups
			// Build an array of selected values: [option1, option2, option3]
			const allOptionGroups = document.querySelectorAll('.lpv2-variant-radios');
			const selectedOptionsArray = [];
			
			allOptionGroups.forEach(function(group) {
				const checkedRadio = group.querySelector('input[type="radio"]:checked');
				if (checkedRadio) {
					selectedOptionsArray.push(checkedRadio.value);
				}
			});
			
			// Find variant that matches ALL selected options in the correct order
			const variant = window.LPV2ProductVariants.find(function(v) {
				// Match each option position
				// option1 must match selectedOptionsArray[0], option2 must match selectedOptionsArray[1], etc.
				if (selectedOptionsArray.length >= 1 && v.option1 !== selectedOptionsArray[0]) return false;
				if (selectedOptionsArray.length >= 2 && v.option2 !== selectedOptionsArray[1]) return false;
				if (selectedOptionsArray.length >= 3 && v.option3 !== selectedOptionsArray[2]) return false;
				return true;
			});
			
			if (variant) {
				if (variant.id !== stateManager.getState().selectedVariantId) {
					stateManager.setVariant(variant);
				}
				if (variant.price !== stateManager.getState().price) {
					stateManager.setState({ price: variant.price });
				}
			}
		});
	});
} 